/**
 * OpenAI Ads Pixel — Cart Event Tracking
 * Hooks into the Dawn/Calibre theme pubsub system to fire items_added
 * when a product is successfully added to the cart.
 *
 * Loaded from theme.liquid. Works alongside the pixel init already in <head>.
 * Checkout events (checkout_started, order_created) are handled separately
 * via Shopify Customer Events.
 */

(function () {
  // Wait for pubsub to be available (it's loaded deferred, same as this file)
  function initCartTracking() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      // Retry — pubsub.js and constants.js load deferred, timing can vary
      setTimeout(initCartTracking, 100);
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      // Only fire on product-form add-to-cart actions
      if (!data || data.source !== 'product-form') return;

      var cartData = data.cartData;
      if (!cartData) return;

      // Shopify /cart/add.js returns either:
      //   { items: [...], sections: {...} }  — when sections are requested (this theme)
      //   { id, title, price, ... }          — single item, no sections
      var addedItems = (cartData.items && cartData.items.length)
        ? cartData.items
        : (cartData.product_id ? [cartData] : []);

      if (!addedItems.length) return;

      // Amount totals — Shopify prices are already in cents (lowest denomination)
      var totalAmount = addedItems.reduce(function (sum, item) {
        return sum + (item.price * item.quantity);
      }, 0);

      var currency = (addedItems[0].currency || 'AUD').toUpperCase();

      var contents = addedItems.map(function (item) {
        return {
          id: item.sku || String(item.variant_id),
          name: item.product_title || item.title,
          content_type: 'product',
          quantity: item.quantity,
          amount: item.price * item.quantity,
          currency: (item.currency || 'AUD').toUpperCase()
        };
      });

      oaiq('measure', 'items_added', {
        type: 'contents',
        amount: totalAmount,
        currency: currency,
        contents: contents
      });
    });
  }

  initCartTracking();
})();
